import { RequestKind, boolean, string } from '@sb/library/base';
import { DisplayItemCollection, TagDisplayItem, TagInputItem, TagMergeInputItem, TagSearchOptions, TagUpdateItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace TagRoutes {
    export const Get = ApiRoute.Define({
        URL: (tagID: string) => `tags/${tagID}`,
        Kind: RequestKind.Get,
        ResultType: TagDisplayItem
    });

    export const GetAll = ApiRoute.Define({
        URL: `tags`,
        Kind: RequestKind.Get,
        ResultType: DisplayItemCollection<TagDisplayItem>
    });

    export const Add = ApiRoute.Define({
        URL: `tags`,
        Kind: RequestKind.Post,
        BodyType: TagInputItem,
        ResultType: string
    });

    export const Update = ApiRoute.Define({
        URL: (tagID: string) => `tags/${tagID}`,
        Kind: RequestKind.Put,
        BodyType: TagUpdateItem,
        ResultType: boolean
    });

    export const Merge = ApiRoute.Define({
        URL: 'tags/merge',
        Kind: RequestKind.Post,
        BodyType: TagMergeInputItem,
        ResultType: boolean
    })

    export const Delete = ApiRoute.Define({
        URL: (tagID: string) => `tags/${tagID}`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });

    export const Search = ApiRoute.Define({
        URL: `search/tags`,
        Kind: RequestKind.Post,
        BodyType: TagSearchOptions,
        PagingAllowed: true,
        ResultType: DisplayItemCollection<TagDisplayItem>
    });
}
